import React from "react";
import { labels } from "../../../../../localization/labels";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import LifeCycleClassDefinitionService from "../../../../../services/LifeCycleClassDefinitionService";
import LifeCycleService from "../../../../../services/LifeCycleService";
import { constants } from "../../../../../utils/Constants";
import PathUtil from "../../../../../utils/PathUtil";
import {
  lifeCycleValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";
import TableUtils from "../../../../core/Table/TableUtils";
import { paths } from "../../../../paths";
import TableComponentWithDialog from "../../../page/TableComponentWithDialog";
import LifeCycleClassDefinitionDetails from "./LifeCycleClassDefinitionDetails";

class LifeCycleClassDefinitionDetailsContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);
    this.id = this.resolveItemId();

    this.props = props;
    this.lifeCycleService = new LifeCycleService();
    this.lifeCycleClassDefinitionService = new LifeCycleClassDefinitionService();
    this.state = {
      ...this.state,
      lifeCycleClassDefinition: {},
      disabled: true,
      selectRow: this.selectRow
    };
  }

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      classes: "column-id",
      headerClasses: "column-header-id"
    },
    {
      dataField: "name",
      text: labels.name,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "dateFromTo.dateFrom",
      text: labels.dateFrom,
      headerClasses: "column-header",
      formatter: TableUtils.dateFormatter
    },
    {
      dataField: "dateFromTo.dateTo",
      text: labels.dateTo,
      headerClasses: "column-header",
      formatter: TableUtils.dateFormatter
    },
    {
      dataField: "lifeCycleStateType.name",
      text: labels.lifeCycleStateType,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    }
  ]);

  componentDidMount() {
    if (this.id) {
      this.loadLifeCycleClassDefinition(this.id);
    } else {
      this.setComponentTitle(labels.lifeCycleClassDefinition);
    }
  }

  getComponentTitle = () => {
    return this.state.lifeCycleClassDefinition.name
      ? this.state.lifeCycleClassDefinition.name
      : undefined;
  };

  loadLifeCycleClassDefinition = id => {
    this.prepareCall(
      this.lifeCycleClassDefinitionService.getLifeCycleClassDefinition(
        id,
        this.onLifeCycleClassDefinitionLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLifeCycleClassDefinitionLoad = data => {
    this.setState({ lifeCycleClassDefinition: data });
    this.setComponentTitle(this.state.lifeCycleClassDefinition.name, true);
    this.loadLifeCycles(data);
  };

  loadLifeCycles = lifeCycleClassDefinition => {
    const url = lifeCycleClassDefinition._links.lifeCycles.href;

    this.prepareCall(
      this.lifeCycleService.getEntitiesWithParams(
        url,
        activeFilterPageInfo,
        this.sortInfo,
        this.onLifeCyclesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  getNonSelectableRows = () => {
    return this.state.initialLifeCycle ? [...this.state.initialLifeCycle] : [];
  };

  onLifeCyclesLoad = data => {
    let { selectRow, lifeCycleClassDefinition } = this.state;
    if (data && data._embedded && data._embedded.content) {
      lifeCycleClassDefinition.lifeCycles = data._embedded.content;
      const initialLifeCycle = data._embedded.content
        .filter(
          item =>
            item.lifeCycleStateType.id ===
            constants.LIFE_CYCLE_STATE_TYPE_PROTECTED_INITIAL
        )
        .map(item => item.id);
      this.setState({ initialLifeCycle: initialLifeCycle });
    } else {
      lifeCycleClassDefinition.lifeCycles = [];
    }

    this.setState({
      lifeCycleClassDefinition: lifeCycleClassDefinition,
      content: lifeCycleClassDefinition.lifeCycles,
      disabled: false,
      selectRow: selectRow
    });
  };

  onRowClick = (_, row) => {
    const itemPath = PathUtil.adminItemsPath(
      { path: paths.LIFE_CYCLE },
      { path: paths.DETAIL, id: row.id }
    );
    this.changePath(itemPath, row.name);
  };

  onDeleteData = lifeCycle => {
    this.prepareCall(
      this.lifeCycleService.deleteEntity(
        lifeCycle,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDataDeleteResponse = data => {
    this.loadLifeCycleClassDefinition(this.id);
  };

  handleCreate = () => {
    const itemPath = PathUtil.adminItemsPath(
      { path: paths.LIFE_CYCLE },
      { path: paths.DETAIL }
    );
    this.changePath(itemPath, labels.lifeCycle, {
      posibleNextLifeCycles: this.state.lifeCycleClassDefinition.lifeCycles,
      lifeCycleClassDiscriminatorId: this.id
    });
  };

  onSave = () => {
    var lifeCycleClassDefinition = this.state.lifeCycleClassDefinition;
    if (lifeCycleClassDefinition && lifeCycleClassDefinition.id) {
      this.prepareCall(
        this.lifeCycleClassDefinitionService.putEntity(
          lifeCycleClassDefinition,
          this.onDataResponse,
          this.messageHandler.handleError,
          this.onSaveSuccessMessage
        )
      );
      this.performCalls();
    }
  };

  onChange = event => {
    var lifeCycleClassDefinition = this.state.lifeCycleClassDefinition;
    lifeCycleClassDefinition[event.target.id] = event.target.value;
    const disabled = !this.validator(lifeCycleClassDefinition);
    this.setState({
      lifeCycleClassDefinition: lifeCycleClassDefinition,
      disabled: disabled
    });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.lifeCycleClassDefinition);
  };

  onDataResponse = data => {
    this.id = data.id;
    this.loadLifeCycleClassDefinition(this.id);
  };

  render() {
    return (
      <LifeCycleClassDefinitionDetails
        {...this.renderProps()}
        lifeCycleClassDefinition={this.state.lifeCycleClassDefinition}
        data={this.state.lifeCycleClassDefinition}
        handleCreate={this.handleCreate}
        onChange={this.onChange}
        disabled={this.state.disabled}
        validationRules={validationRules.lifeCycleClassDefinition}
      />
    );
  }
}

export default LifeCycleClassDefinitionDetailsContainer;
